var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 49.913,24.865 35.514,59.171 H 26.1357 L 19.0584,31.803 C 18.64004,30.1295 18.25654,29.502 16.9317,28.8047 14.805,27.6193 11.2838,26.5386 8.1809,25.8762 l 0.20918,-1.011 h 15.096 c 1.9175,0 3.6607,1.29 4.079,3.4864 l 3.7304,19.872 9.2737,-23.359 z M 86.659,47.98 c 0.03488,-9.0645 -12.516,-9.5526 -12.446,-13.597 0.03488,-1.2202 1.1854,-2.545 3.7653,-2.8588 1.2551,-0.17432 4.7763,-0.27891 8.7508,1.534 l 1.5689,-7.2865 c -2.1267,-0.767 -4.8809,-1.4991 -8.2975,-1.4991 -8.7856,0 -14.956,4.6717 -14.991,11.331 -0.06976,4.9506 4.3928,7.7048 7.7746,9.3434 3.4515,1.6735 4.6369,2.7542 4.602,4.2534 -0.03488,2.301 -2.7542,3.312 -5.2993,3.3469 -4.4625,0.06973 -7.0424,-1.2202 -9.0994,-2.1615 l -1.6037,7.5305 c 2.0918,0.94132 5.8919,1.778 9.8664,1.8129 9.2737,0 15.375,-4.602 15.41,-11.749 m 23.184,11.226 h 8.1929 l -7.1819,-34.341 h -7.5654 c -1.7083,0 -3.1377,0.97618 -3.7653,2.5102 l -13.318,31.796 h 9.3086 l 1.8478,-5.1249 h 11.4 z m -9.9361,-12.167 4.6717,-12.9 2.6845,12.9 z m -37.339,-22.173 -7.3213,34.306 h -8.8902 l 7.3562,-34.306 z",
    style: {
      fill: "#1946ba"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/icon-visa.79e10dd123cf97c7371ef44cb8138471.svg";
export { ForwardRef as ReactComponent };